




















































import { Component, Vue } from 'vue-property-decorator';
import { ObjectFactory } from '../../config/objectFactory';
import { validationMixin } from 'vuelidate';
import { MedTransGoConstants } from '../../util/constants';
import { ToastEvent } from '../../types/event';
import { CommonUtils } from '../../util/commonUtils';
import { EventBus } from '../../main';
import DataTable from '../../components/DataTable.vue';
import ConfirmationBox from '../../components/ConfirmationBox.vue';
import { required } from 'vuelidate/lib/validators';
import { Bid, Route } from '@/types/entity';
import { MathUtils } from '@/util/mathUtils';
import { ApiRequest } from '@/types/request';
import { DateUtils } from '@/util/dateUtils';

@Component({
    components: {
        DataTable,
        ConfirmationBox,
    },
    mixins: [validationMixin],
    data() {
        return {
            amount: '',
            closeTime: '',
            biddingAmount: 0,
            totalDistance: 0,
            estimatedPayout: 0,
        };
    },
    validations: {
        amount: {
            required,
        },
    },
})
export default class AuctionModal extends Vue {
    private show = true;
    private showConfirmBox = false;
    private id = this.$route.params.id;
    private sessionInfo = ObjectFactory.getCacheService().getSessionInfo();
    private mapRoutes: Route[] = [];
    private MathUtils = MathUtils;

    public async mounted() {
        this.getRequestDetails();
    }

    private async getRequestDetails() {
        const response = await ObjectFactory.getRequestService().
            getRequestDetails(this.id, this.$store.state.serverUrl);
        if (response && response.data && response.data.assignment.auction &&
            response.data.assignment.auction.bids) {
            if (response.data && response.data.transportRequest) {
            this.mapRoutes = response.data.transportRequest.mapRoutes;
            this.$data.totalDistance = 0;
            this.$data.estimatedPayout = 0;
            this.mapRoutes.forEach((route) => {
                if (route.totalMiles) {
                    this.$data.totalDistance += route.totalMiles;
                }
                if (route.estimatedPayout) {
                    this.$data.estimatedPayout += route.estimatedPayout;
                }
            });
            }
            this.$data.closeTime = DateUtils.formatDate(response.data.assignment.auction.closeTime);
            const currentBids = response.data.assignment.auction.bids.
                filter((bid) => bid.transporterId === this.sessionInfo.id);
            const bids = currentBids.sort((bid1, bid2) => bid1.amount < bid2.amount ? -1 : 1);
            this.$data.biddingAmount = MathUtils.formatCurrency(bids[0].amount);
        }
    }
    private close() {
        this.$router.push({ path: `${MedTransGoConstants.URL_REQUESTS}/${this.id}`});
    }
    private async submitBid() {
        const iHttpService = ObjectFactory.getHttpService();
        const addBidRequest: Bid = {
            amount : MathUtils.convert$ToCents(this.$data.amount),
        };
        const apiRequest: ApiRequest = {
          baseURL: this.$store.state.serverUrl,
          url: `${MedTransGoConstants.HTTP_URL_REQUESTS}/${this.id}/bid`,
          data: addBidRequest,
          loaderEvent: {
              show: true,
          },
        };
        const response = await iHttpService.put<any>(apiRequest);
        if (response.success) {
            const toastEvent: ToastEvent = {
                message: 'Bid has been added successfully..',
                title: 'Success!',
                timeout: 2000,
                varient: 'success',
            };
            EventBus.$emit(MedTransGoConstants.EVENT_SHOW_TOAST, toastEvent);
            this.showConfirmBox = false;
            this.getRequestDetails();
            this.close();
        } else {
            CommonUtils.showError(response);
        }
    }
}
